<template>
    <div class="">
        <div class="flex pb-3">
            <div class="flex-shrink-0 cursor-pointer">
                <img v-if="check" @click="toggleCheck()" class="ml-0 mr-2 my-auto w-5 h-5"  src="@/assets/icon/ic-checkbox-brown.svg" />
                <div v-else @click="toggleCheck()" class="ml-0 mr-2 my-auto w-5 h-5 rounded-5 border border-a-brown-d7c7b8 bg-white"></div>
            </div>

            <div v-if="text != null" class="pl-2 text-14 lg:text-16 text-a-brown-502314 ml-0 mr-auto my-auto" v-html="text"></div>
            <div v-else>
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Checkbox",
    props: {
        check: { type: Boolean }, // v-model:check
        text: { type: String, default: null },
    },
    methods: {
        toggleCheck: function() {
            let value = !this.check;
            this.$emit('update:check', value);
        },

        setCheck: function (isCheck) {
            this.$emit('update:check', isCheck);
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
